'use strict';

module.exports = require('./lib/get-css');



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/get-css.js
 ** module id = 23
 ** module chunks = 0
 **/